<template>
  <transition name="viewer-fade">
    <div :style="{ 'z-index': zIndex }" class="el-image-viewer__wrapper">
      <div class="el-image-viewer__mask" @click="hide"></div>
      <!-- CLOSE -->
      <span class="el-image-viewer__btn el-image-viewer__close" @click="hide">
				<i class="el-icon-circle-close"></i>
			</span>
      <!-- ARROW -->
      <template v-if="!isSingle">
				<span :class="{ 'is-disabled': !infinite && isFirst }" class="el-image-viewer__btn el-image-viewer__prev"
              @click="prev">
					<i class="el-icon-arrow-left"/>
				</span>
        <span :class="{ 'is-disabled': !infinite && isLast }" class="el-image-viewer__btn el-image-viewer__next"
              @click="next">
					<i class="el-icon-arrow-right"/>
				</span>
      </template>
      <!-- ACTIONS -->
      <div class="el-image-viewer__btn el-image-viewer__actions">
        <div class="el-image-viewer__actions__inner">
          <i v-if="urlList[index]&&urlList[index].isSee!=true" class="OriginalImage" @click="viewOriginalImage">查看原图</i>
          <i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
          <i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <i :class="mode.icon" @click="toggleMode"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
          <i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
        </div>
      </div>
      <!-- CANVAS -->
      <div class="el-image-viewer__canvas">
        <img v-for="(item, i) in urlList" v-if="i === index" :key="i" ref="img" :src="currentImg[url]+'?Authorization='+userInfo.token+'&us=web'"
             :style="imgStyle"
             class="el-image-viewer__img" @error="handleImgError" @load="handleImgLoad" @mousedown="handleMouseDown">
      </div>


    </div>
  </transition>
</template>

<script>
import {mapGetters} from 'vuex';
//非父子组件传值
import {off, on} from 'element-ui/src/utils/dom';
import {isFirefox, rafThrottle} from 'element-ui/src/utils/util';

const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};

const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';

export default {
  name: 'elImageViewer',

  props: {
    url: {
      type: String,
      default: () => 'url'
    },
    uuid: {//请求下个接口所带的参数变量
      type: String,
      default: () => 'uuid'
    },
    urlList: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: () => {
      }
    },
    onClose: {
      type: Function,
      default: () => {
      }
    },
    showIndex: { //显示第几张图片
      type: Number,
      default: 0
    },
    loop: {//是否循环显示 默认开启
      type: Boolean,
      default: () => {
        return true
      }
    },
  },

  data() {
    return {
      index: 0,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'api', 'orgInfo']), //获取
    isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg() {
      console.log(this.urlList[this.index]);
      console.log(this.index);
      return this.urlList[this.index];
    },
    imgStyle() {
      const {
        scale,
        deg,
        offsetX,
        offsetY,
        enableTransition
      } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    }
  },
  watch: {
    index: {
      handler: function (val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg(val) {
      this.$nextTick(_ => {
        const $img = this.$refs.img[0];
        if ($img && !$img.complete) {
          this.loading = true;
        }
      });
    }
  },
  mounted() {
    this.index = this.showIndex
    this.deviceSupportInstall();
  },
  methods: {
    //查看原图
    viewOriginalImage() {
      console.log(this.urlList);
      let that = this
      that.GLOBAL.doPost(that.api.GLOBAL_file_fileInfo_getOriginalPictureURLByFileId, {
        fileId: that.urlList[that.index][that.uuid]
      }, function (res) {
        if (res.code == 200) {
          if (res.data.includes('?')) {
            that.urlList[that.index][that.url] = res.data + '&Authorization=' + that.userInfo.token+'&us=web';
            that.urlList[that.index].isSee = true//是否查看过true为查看过
          } else {
            that.urlList[that.index][that.url] = res.data + '?Authorization=' + that.userInfo.token+'&us=web';
            that.urlList[that.index].isSee = true//是否查看过true为查看过
          }

        }
      });

    },
    hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall() {
      this._keyDownHandler = rafThrottle(e => {
        const keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            this.hide();
            break;
          // SPACE
          case 32:
            this.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            this.prev();
            break;
          // UP_ARROW
          case 38:
            this.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            this.next();
            break;
          // DOWN_ARROW
          case 40:
            this.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = rafThrottle(e => {
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          this.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          this.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(document, 'keydown', this._keyDownHandler);
      on(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall() {
      off(document, 'keydown', this._keyDownHandler);
      off(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad(e) {
      this.loading = false;
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown(e) {
      if (this.loading || e.button !== 0) return;

      const {
        offsetX,
        offsetY
      } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, 'mousemove', this._dragHandler);
      on(document, 'mouseup', ev => {
        off(document, 'mousemove', this._dragHandler);
      });

      e.preventDefault();
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode() {
      if (this.loading) return;

      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index = modeValues.indexOf(this.mode);
      const nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      if (modeNames[nextIndex] == 'ORIGINAL') {
        this.transform = {
          scale: 1.1,
          deg: 0,
          offsetX: 0,
          offsetY: 0,
          enableTransition: false
        };
      } else {
        this.reset();
      }

    },
    prev() {
      if (this.isFirst && !this.infinite) return;
      const len = this.urlList.length;
      //判断是否开启循环
      if (this.loop) {
        this.index = (this.index - 1 + len) % len;
      } else {
        if (this.index == 0) {
          return
        }
        this.index--
      }
    },
    next() {
      if (this.isLast && !this.infinite) return;
      const len = this.urlList.length;
      //判断是否开启循环
      if (this.loop) {
        this.index = (this.index + 1) % len;
      } else {
        if (this.index == len - 1) {
          return
        }
        this.index++
      }
    },
    handleActions(action, options = {}) {
      if (this.loading) return;
      const {
        zoomRate,
        rotateDeg,
        enableTransition
      } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      };
      const {
        transform
      } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    }
  }
};
</script>
<style lang="scss" scoped="scoped">
@import "./imageViewer.scss";
</style>



// WEBPACK FOOTER //
// src/components/imageViewer/imageViewer.vue